var changer = require('./themeColorChanger.js')
var varyColor = require('./varyColor')

module.exports = {
    changer: changer,
    varyColor: varyColor
}



//////////////////
// WEBPACK FOOTER
// (webpack)-theme-color-replacer/client/index.js
// module id = uZQj
// module chunks = 23